// Copyright 2025 - Hewlett Packard Enterprise Company
import { useContext } from 'react';
import { Grommet } from 'grommet';
import { hpe } from 'grommet-theme-hpe';

import { ThemeModeContext } from './providers/ThemeModeProvider';

export default function ThemedApp({ children }) {
  const { themeMode } = useContext(ThemeModeContext);
  return (
    <Grommet theme={hpe} themeMode={themeMode}>
      {children}
    </Grommet>
  );
}
